import { safeAnyIgnoringPromise, safeSync } from '@src/utils/safe'

export type FireAndForgotTask = () => void | Promise<void>

export function executeFireAndForgotTask(task: FireAndForgotTask, timeout: number) {
  if (typeof window.requestIdleCallback != 'undefined') {
    const id = requestIdleCallback(safeAnyIgnoringPromise(task), { timeout })
    return safeSync(() => {
      cancelIdleCallback(id)
    })
  }
  // Fallback to setTimeout
  const id = setTimeout(safeAnyIgnoringPromise(task), timeout)
  return safeSync(() => {
    clearTimeout(id)
  })
}
